import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Button } from '@monorepo/button';
import { Modal } from '@monorepo/modal';
import { Heading, Text } from '@monorepo/typography';
import { useTranslation } from '@monorepo/localization';
import styled from '@emotion/styled';

const EditScreenContainer = styled.div `
    padding-bottom: 70px;
    ${({ theme }) => theme.mediaQueries.sm} {
        width: 630px;
    }
    ${({ theme }) => theme.mediaQueries.lg} {
        width: 954px;
    }
    ${({ theme }) => theme.mediaQueries["2xl"]} {
        width: 1290px;
    }
    margin: 0 auto;
    > a:first-child {
        padding-top: 30px;
        padding-bottom: 30px;
    }
`;
const StyledModal = styled(Modal) `
    align-self: center;
    min-height: unset;
    width: 290px;
    ${({ theme }) => theme.mediaQueries.sm} {
        width: 630px;
        padding: 30px 20px;
    }
    ${({ theme }) => theme.mediaQueries.lg} {
        width: 954px;
        padding: 45px 30px;
    }
`;
styled(Modal) `
    background: #f7f7f7;
    display: flex;
    flex-direction: column;
    gap: 30px;
    h4 {
        margin-bottom: 20px;
    }
    align-self: center;
    min-height: unset;
    width: 363px;
    padding: 45px 15px 30px 15px;
    ${({ theme }) => theme.mediaQueries.sm} {
        width: 630px;
        padding: 30px 35px;
    }
    ${({ theme }) => theme.mediaQueries.lg} {
        width: 954px;
        padding: 45px 45px 30px 45px;
    }
`;
const TitleContainer = styled.div `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    margin-bottom: 30px;
    align-self: stretch;
`;
const ButtonsRow = styled.div `
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 15px;
    align-self: stretch;
`;
const UnsavedChanges = ({ handleClose, handleProceed }) => {
    const { t } = useTranslation("privacy-portal");
    return (jsxs(StyledModal, { handleClose: handleClose, children: [jsxs(TitleContainer, { id: "unsaved-changes-modal", children: [jsx(Heading.Small, { children: t("You have unsaved changes.") }), jsx(Text.Medium, { children: t("Are you sure you want to leave this page? Your changes won’t be saved.") })] }), jsxs(ButtonsRow, { children: [jsx(Button, { hollow: true, onClick: handleProceed, id: "unsaved-changes-modal-leave-button", children: t("Leave Page") }), jsx(Button, { onClick: handleClose, id: "unsaved-changes-modal-stay-button", children: t("Stay on Page") })] })] }));
};
const SubpageWrapper = ({ children, hasUnsavedChanges, backBtnConfigs }) => {
    const { t } = useTranslation("privacy-portal");
    const { label, href, handleProceed } = backBtnConfigs;
    const [isUnsavedChangeModalOpen, setUnsavedChangeModalOpen] = useState(false);
    return (jsxs(Fragment, { children: [jsxs(EditScreenContainer, { children: [jsx(Button, { secondary: true, reverse: true, href: href, onClick: (e) => {
                            e.preventDefault();
                            if (hasUnsavedChanges) {
                                setUnsavedChangeModalOpen(true);
                            }
                            else {
                                handleProceed(e);
                            }
                        }, id: "back-to-previous-page", children: t("Back to {{PAGE}}", { PAGE: label }) }), children] }), isUnsavedChangeModalOpen && (jsx(UnsavedChanges, { handleClose: () => {
                    setUnsavedChangeModalOpen(false);
                }, handleProceed: handleProceed }))] }));
};

export { SubpageWrapper };
